import angular from 'angular';
import { AutoFillSync } from './autofill-sync.directive.js';
import { IfPerm } from './if-perm.directive';
import { ClickMeOnEnter } from './click-me-on-enter.directive';

import TapOutside from './tap-outside.directive';
import { StripeElementDirective } from './stripe-element.directive';
import AdjustDirective from './adjust.directive';
import SortByDirective from './sort-by.directive';

let directiveModule = angular.module('app.directiveModule', [
])
// .directive('autoFillSync', AutoFillSync)
.directive('ifPerm', IfPerm)
.directive('clickMeOnEnter', ClickMeOnEnter)
.directive('tapOutside', TapOutside)
.directive('stripeElement', StripeElementDirective)
.directive('adjust', AdjustDirective)
.directive('sort', SortByDirective)
.name;

export default directiveModule;


// WEBPACK FOOTER //
// ./src/app/directives/directives.js